import {
  Text,
  View,
  ScrollView,
  TouchableOpacity,
  Modal,
  Pressable,
  ActivityIndicator,
} from "react-native";
import React from "react";
import { useRouter, useLocalSearchParams } from "expo-router";
import Icon from "react-native-vector-icons/FontAwesome";
import { selectedLocation } from "../redux/actions/scaleactions";
import { useSelector, useDispatch } from "react-redux";
import FooterComponent from "../component/footer";
import { useLanguage } from "./LanguageProvider";

export default function detaillocation() {
  const router = useRouter();
  const { t } = useLanguage();
  const {
    item: itemParams,
    scale: itemParamscale,
    item2: itemParam2,
    data: itemData,
  } = useLocalSearchParams();

  const item =
    typeof itemParams === "string" ? JSON.parse(itemParams) : itemParams;

  const scale =
    typeof itemParamscale === "string"
      ? JSON.parse(itemParamscale)
      : itemParamscale;

  const item2 =
    typeof itemParam2 === "string" ? JSON.parse(itemParam2) : itemParam2;

  const dataparam =
    typeof itemData === "string" ? JSON.parse(itemData) : itemData;

  const responseparams =
    useSelector((state: any) => state?.scale?.postweight) || null;

  const [modalVisible, setModalVisible] = React.useState(false);
  const [modalSuccessVisible, setModalSuccessVisible] = React.useState(false);
  const [modalFailedVisible, setModalFailedVisible] = React.useState(false);
  const [loadingresponse, setLoadingresponse] = React.useState(false);
  const dispatch = useDispatch();

  const handlesubmit = async () => {
    try {
      // console.log("scale", JSON.stringify(scale, null, 2)); //มี product_id, reel_no, employee_code,
      // console.log("item", JSON.stringify(item, null, 2)); //มี storage_location
      // console.log("item2", JSON.stringify(item2, null, 2));
      // console.log("dataparam", JSON.stringify(dataparam, null, 2));
      // console.log("response", JSON.stringify(responseparams, null, 2)); //มี materialdoc

      setLoadingresponse(true);
      const response = await dispatch(
        selectedLocation(item, scale, responseparams) as any
      );
      // setLoadingresponse(false);
      if (response.success === true) {
        setModalSuccessVisible(true);
      } else {
        console.log(response);
        setModalFailedVisible(true);
      }
    } catch (error: any) {
      console.log(error);
      setModalFailedVisible(true);
    } finally {
      setLoadingresponse(false);
    }
  };

  return (
    <>
      <View className="flex-1 bg-[#F17736] items-center justify-center">
        <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]"></View>
        <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]"></View>

        <FooterComponent />

        {/* ScrollView ครอบเนื้อหาทั้งหมด */}
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "space-between",
            padding: 20,
          }}
          showsVerticalScrollIndicator={false}
          className="absolute mt-2 top-0 w-[90%] h-[80%] px-2 bg-white rounded-2xl border border-gray-200 shadow-md"
        >
          <View className="w-full items-center justify-center border-b border-gray-300 pb-1">
            {/* <Text className="text-2xl font-kanit py-2">รายละเอียดสถานที่</Text> */}
            <Text className="text-2xl font-kanit py-2">
              {t("location_details")}
            </Text>
          </View>

          <View className="w-full flex-1 pt-2">
            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* ชื่อสถานที่ */}
                {t("location_name")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item.desc_location ? item.desc_location : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* แผนงาน */}
                {t("plan")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item.plan ? item.plan : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* โรงงาน */}
                {t("factory")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item.factory ? t("factory") + " " + item.factory : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* สถานที่เก็บข้อมูล */}
                {t("storage_location")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item.storage_location ? item.storage_location : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* ประเภท */}
                {t("type")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item.type ? item.type.toUpperCase() : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* เครื่องจักร */}
                {t("machine")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item.machine_code ? item.machine_code : t("no_data")}
              </Text>
            </View>
          </View>

          <View className="w-full items-center justify-center py-2 border-t pt-5 border-gray-300">
            <TouchableOpacity
              // onPress={() => router.push("/screens/scanlocation")}
              // onPress={() => handlesubmit()}
              onPress={() => setModalVisible(true)}
              className="w-full bg-[#58d68d] py-3 rounded-xl items-center shadow-sm"
            >
              <Text className="text-white text-lg font-kanit">
                {/* เลือกสถานที่ */}
                {t("select_storage_location")}
              </Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => setModalVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#F17736" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* ยืนยันข้อมูล */}
                {t("question_send")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {/* คุณต้องการเลือกสถานที่จัดเก็บนี้ใช่หรือไม่? */}
              {t("confirm_select_storage_location")}
            </Text>

            {/* Buttons */}
            <View className="flex-row justify-around">
              {/* Cancel Button */}
              <Pressable
                className="flex-1 bg-gray-300 py-2 rounded-lg mx-1"
                // onPress={() => setModalVisible(false)}
                onPress={() => {
                  setModalVisible(false);
                }}
              >
                <Text className="text-center text-gray-700 font-kanit">
                  {/* ยกเลิก */}
                  {t("cancel")}
                </Text>
              </Pressable>

              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalVisible(false);
                  handlesubmit();
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {/* ยืนยัน */}
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalSuccessVisible}
        onRequestClose={() => setModalSuccessVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="check-circle" size={28} color="#58d68d" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* สำเร็จ */}
                {t("success")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {/* คุณได้เลือกสถานที่จัดเก็บเรียบร้อยแล้ว */}
              {t("success_select_storage_location")}
            </Text>

            {/* Buttons */}
            <View className="flex-row justify-around">
              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-3 rounded-lg mx-1"
                onPress={() => {
                  setModalSuccessVisible(false);
                  router.push({
                    pathname: "/screens/scanlocation",
                    params: {
                      item: JSON.stringify(item),
                      item2: JSON.stringify(item2),
                      scale: JSON.stringify(scale),
                      data: JSON.stringify(dataparam),
                    },
                  });
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {/* ตกลง */}
                  {t("ok")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalFailedVisible}
        onRequestClose={() => setModalFailedVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#ec7063" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* ไม่สำเร็จ */}
                {t("error")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {/* เลือกสถานที่จัดเก็บไม่สำเร็จ */}
              {t("error_select_storage_location")}
            </Text>

            {/* Buttons */}
            <View className="flex-row justify-around">
              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-3 rounded-lg mx-1"
                onPress={() => {
                  setModalFailedVisible(false);
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {/* ตกลง */}
                  {t("ok")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={loadingresponse}
        onRequestClose={() => setLoadingresponse(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          {/* Header */}
          <View className="flex items-center justify-center pb-3">
            <ActivityIndicator size="large" color="#F17736" />
            <Text className="text-center text-xl font-kanit text-white pl-2 pt-2">
              {/* กำลังส่งข้อมูล... */}
              {t("loading_send_data")}
            </Text>
          </View>
        </View>
      </Modal>
    </>
  );
}
